import { render, staticRenderFns } from "./guesslikeaddCardBtn.vue?vue&type=template&id=6dc0e086&scoped=true&"
import script from "./guesslikeaddCardBtn.vue?vue&type=script&lang=js&"
export * from "./guesslikeaddCardBtn.vue?vue&type=script&lang=js&"
import style0 from "./guesslikeaddCardBtn.vue?vue&type=style&index=0&id=6dc0e086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc0e086",
  null
  
)

export default component.exports